import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CompassOutlined, DollarOutlined, OrderedListOutlined, SettingOutlined, CopyFilled, FileImageOutlined, PicLeftOutlined } from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import Router from './Routes';

function App() {
	const [collapsed, setCollapsed] = useState(false);
	const navigate = useNavigate();

	return (
		<Layout
			style={{
				minHeight: '100vh',
			}}
		>
			<Layout.Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
				<div
					style={{
						height: 60,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<img src='/images/logo.png' alt='Logo' style={{ height: 18, width: 'auto' }} />
				</div>

				<Menu
					theme='dark'
					defaultSelectedKeys={['1']}
					mode='inline'
					items={[
						{
							label: 'Events',
							icon: <CompassOutlined />,
							onClick: () => {
								navigate('/events');
							},
						},
						{
							label: 'Bookings',
							icon: <DollarOutlined />,
							onClick: () => {
								navigate('/bookings');
							},
						},
						{
							label: 'Event Types',
							icon: <OrderedListOutlined />,
							onClick: () => {
								navigate('/event-types');
							},
						},
						{
							label: 'Main Slider',
							icon: <FileImageOutlined />,
							onClick: () => {
								navigate('/main-slider');
							},
						},
						{
							label: 'Manage Home Page',
							icon: <PicLeftOutlined />,
							onClick: () => {
								navigate('/manage-home-page');
							},
						},
						{
							label: 'Note Templates',
							icon: <CopyFilled />,
							onClick: () => {
								navigate('/note-templates');
							},
						},
						{
							label: 'Settings',
							icon: <SettingOutlined />,
							onClick: () => {
								navigate('/setting/add');
							},
						},
						{
							label: 'Gallery',
							icon: <SettingOutlined />,
							onClick: () => {
								navigate('/gallery');
							},
						},
					]}
				/>
			</Layout.Sider>
			<Layout className='site-layout'>
				<Router />
				<Layout.Footer
					style={{
						padding: '8px 16px',
						textAlign: 'center',
						fontSize: 11,
					}}
				>
					Developed by Dot and Dash Technologies Pvt. Ltd.
				</Layout.Footer>
			</Layout>
		</Layout>
	);
}

export default App;
